import {
  Avatar,
  Box,
  Dialog,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useCallback,
} from "react";
import { appImages } from "../../../../assets";
import DialogBody from "../../../../components/dialog/DialogBody";
import CloseIcon from "@mui/icons-material/Close";

// Custom dialog styles
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

// Reusable component for actions in the dialog
const ActionBox = ({ label, onClick }) => (
  <Box
    onClick={onClick}
    px={1}
    py={1.5}
    bgcolor={"#EDF1F566"}
    borderRadius={2}
    border={"1px solid #dfe2e5"}
    sx={{ cursor: "pointer" }}
  >
    <Typography variant="body1" fontWeight={500}>
      {label}
    </Typography>
  </Box>
);

const StudentCardDialog = forwardRef(
  ({ handleViewIDCard, handleRequestNewCard }, ref) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      openDialog(params) {
        setOpen(true);
      },
      closeDialog() {
        setOpen(false);
      },
    }));

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 5,
            right: 5,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogBody>
          <Stack alignItems="center" mb={6}>
            <Avatar
              src={appImages.schoolBoyImage}
              sx={{ height: 130, width: 130 }}
            />
          </Stack>

          <Grid container rowSpacing={2} my={2}>
            <Grid item xs={12}>
              <ActionBox label="View ID Card" onClick={handleViewIDCard} />
            </Grid>
            <Grid item xs={12}>
              <ActionBox
                label="Request For New Card / Lost Card"
                onClick={handleRequestNewCard}
              />
            </Grid>
          </Grid>
        </DialogBody>
      </BootstrapDialog>
    );
  }
);

export default StudentCardDialog;
